<template>
    <div class="list-dropdown">
        <b-form-checkbox-group
                v-model="internalModel"
                name="listDropdown"
                :options="options"
                value-field="value"
                text-field="label"
                stacked
        />
    </div>
</template>
<script>
    import './ListDropdwn.scss';
    import VModel from "@milestoneslabs/milestones-ui-kit/src/mixins/VModel";

    export default {
        name: 'ListDropdown',
        mixins: [
            VModel
        ],
        props: {
            options: {
                type: Array,
                default: () => []
            }
        },
    };
</script>
